<template>
  <div class="container">
    <div id="success-overlay" class="modal modal-sm modal-success" v-bind:class="{ 'is-active': isCardModalActive }">
      <div class="modal-background scaleInCircle"></div>
      <div class="modal-content scaleIn">
        <div class="flex-card simple-shadow">
          <div class="card-body">
            <div class="content pb-20">
              <h2 class="has-text-centered pb-20">تنبيه</h2>
              <p>
                سيتم ارسال رسالة نصية تحمل كود تأكيد عملية التسجيل الى هذا الرقم
              </p>

              <a class="button btn-align btn-hero is-warning raised is-large">
                <b>{{ register.MobileNo }}</b>
              </a>
            </div>
            <div class="mt-20">
              <a class="button is-info raised btn-align is-large modal-dismiss is-bold ml-10"
                v-bind:class="{ 'is-loading': isLoading }" @click="signUp">
                <b>الاستمرار</b>
              </a>

              <a class="button is-dark btn-align modal-dismiss is-bold is-large" @click="isCardModalActive = false">
                <b>العودة</b>
              </a>
            </div>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" @click="isCardModalActive = false"></button>
    </div>

    <div id="terms-modal" class="modal modal-md modal-success" v-bind:class="{ 'is-active': termsPopup }">
      <div class="modal-background scaleInCircle"></div>
      <div class="modal-content scaleIn" style="max-width: 650px;">
        <div class="flex-card simple-shadow">
          <header class="modal-card-head">
            <p class="modal-card-title p-20"><b> الشروط و الاحكام </b></p>
          </header>
          <div class="card-body" style="padding-top: 0px">
            <div class="content">
              <section class="modal-card-body" style="padding: 20px; max-height: 60vh; overflow-y: auto; text-align: right;">
                <div class="mt-5 mb-10">
                  <div v-if="terms" class="has-text-right is-black is-size-6 has-text-justified" v-html="terms"></div>
                  <loading v-else line-fg-color="#2d3f51" size="large" class="margin-100" spacing="2" text-fg-color="#fff" message="الرجاء الإنتظار" />
                </div>
              </section>
            </div>
            <div class="mt-20">
              <a class="button danger-btn btn-align modal-dismiss is-bold is-medium" @click="termsPopup = false">
                <b> اغلاق </b>
              </a>
            </div>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" @click="termsPopup = false"></button>
    </div>

    <section>
      <div class="container is-vcentered">
        <div class="columns is-centered mt-20">
          <div class="column is-10">
            <span class="title has-text-grey has-text-centered">
              <router-link to="/">
                <img class src="~/../assets/images/logos/brand-logo.png" width="50%" alt />
              </router-link>
              <hr />
              <h4 class="title is-3 has-text-centered mb-20">
                نموذج اعرف زبونك (KYC) للأفراد
              </h4>
              <!-- <hr> -->
            </span>

            <form @submit.prevent="validateBeforeSubmit()">
              <div class="flex-card hover-inset card-overflow">
                <div class="card-body is-medium">
                  <div class="content">
                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label is-large">اختر الفرع</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <!-- <input
                                    class="input is-large"
                                    v-model="register.Branch_id"
                                    type="text"
                                    placeholder="الفرع"
                                    autofocus
                                    disabled
                                    v-validate="'required'"
                                    :class="{'input': true, 'is-danger': errors.has('register.Branch_id') }"
                                >-->
                                <div class="select is-fullwidth is-medium" :class="{ 'is-loading': branchloading }">
                                  <select class="select" v-model="register.Branch_id" oninput="setCustomValidity('')"
                                    name="Branch_id" v-validate="'required'" @change="checkWorkingCalender()"
                                    placeholder="الفرع" :class="{
      input: true,
      'is-danger': errors.has('Branch_id'),
    }">
                                    <option v-for="branch in branches" v-bind:key="branch.code"
                                      v-bind:value="branch.code">
                                      {{ branch.name }}
                                    </option>
                                  </select>
                                </div>
                                <span v-show="errors.has('Branch_id')" class="help is-danger has-text-centered">{{
      errors.first("Branch_id") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div class="columns">
                        <div class="column">
                          <div class="field">
                            <label class="label is-medium">ادخل رقم الحساب
                            </label>

                            <div class="field-body">
                              <div class="field">
                                <div class="control">
                                  <input v-validate="'max:10|min:10'" class="input is-large has-text-centered" v-model="register.MainAccountNo"
                                    @input="errormessage = false" type="text" placeholder="ادخل رقم حسابك "
                                    name="MainAccountNo" :class="{
      input: true,
      'is-danger': errors.has('MainAccountNo'),
    }" />
                                  <span v-show="errors.has('MainAccountNo')" class="help is-danger has-text-centered">{{
      errors.first("MainAccountNo") }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="columns">
                        <div class="column is-fullwidth">
                          <div class="field">
                            <div class="field-body">
                              <div class="field">
                                <label class="label is-medium"
                                  >أو ادخل رقم الحساب القديم</label
                                >
                                <div class="control">
                                  <input
                                    class="input is-large has-text-centered"
                                    v-model="register.OldMainAccountNo"
                                    type="text"
                                    @change="errormessage = false"
                                    placeholder=" رقم حساب القديم"
                                    name="OldMainAccountNo"
                                    :class="{
                                      input: true,
                                      'is-danger':
                                        errors.has('OldMainAccountNo'),
                                    }"
                                    v-validate="'max:15|min:15'"
                                  />
                                  <span
                                    v-show="errors.has('OldMainAccountNo')"
                                    class="help is-danger has-text-centered"
                                    >{{
                                      errors.first("OldMainAccountNo")
                                    }}</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                    <b-message title="تنبيه" type="is-danger" v-if="!hasWorkingCalander && noWorkingMessage != ''"
                      class="pb-10 pt-20">{{ noWorkingMessage }}</b-message>
                  </div>
                </div>
              </div>

              <div class="flex-card light-bordered hover-inset card-overflow">
                <div class="flex-card-header">
                  <div class="header-control">
                    <i class="sl sl-icon-user"></i>
                  </div>
                  <div class="header-info">
                    <div class="header-title mt-20 mb-20">
                      <strong>البيانات شخصية للزبون</strong>
                    </div>
                  </div>
                </div>
                <div class="card-body is-medium">
                  <div class="content">
                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">اسم الزبون</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-medium" v-model="register.FirstName" v-validate="{
      max: 20,
      required: true,
      regex: /^[\u0621-\u064A ]+$/,
    }" type="text" placeholder="اسم الزبون" name="FirstName" :class="{
      input: true,
      'is-danger': errors.has('FirstName'),
    }" />
                                <span v-show="errors.has('FirstName')" class="help is-danger has-text-centered">{{
      errors.first("FirstName") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">اسم الأب</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-medium" v-model="register.FatherName" v-validate="{
      max: 20,
      required: true,
      regex: /^[\u0621-\u064A ]+$/,
    }" type="text" placeholder="اسم الأب" name="FatherName" :class="{
      input: true,
      'is-danger': errors.has('FatherName'),
    }" />
                                <span v-show="errors.has('FatherName')" class="help is-danger has-text-centered">{{
      errors.first("FatherName") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">اسم الجد</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-medium" v-model="register.GrandFatherName" v-validate="{
      max: 20,
      required: true,
      regex: /^[\u0621-\u064A ]+$/,
    }" type="text" placeholder="اسم الجد" name="GrandFatherName" :class="{
      input: true,
      'is-danger': errors.has('GrandFatherName'),
    }" />
                                <span v-show="errors.has('GrandFatherName')" class="help is-danger has-text-centered">{{
      errors.first("GrandFatherName") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">اللقب</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-medium" v-model="register.FamilyName" v-validate="{
      max: 20,
      required: true,
      regex: /^[\u0621-\u064A ]+$/,
    }" type="text" placeholder="اللقب" name="FamilyName" :class="{
      input: true,
      'is-danger': errors.has('FamilyName'),
    }" />
                                <span v-show="errors.has('FamilyName')" class="help is-danger has-text-centered">{{
      errors.first("FamilyName") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- second row -->
                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">اسم الأم</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-medium" v-model="register.MotherName" v-validate="{
      max: 20,
      required: true,
      regex: /^[\u0621-\u064A ]+$/,
    }" type="text" placeholder="اسم الأم" name="MotherName" :class="{
      input: true,
      'is-danger': errors.has('MotherName'),
    }" />
                                <span v-show="errors.has('MotherName')" class="help is-danger has-text-centered">{{
      errors.first("MotherName") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">الجنس</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <div class="select is-fullwidth is-medium">
                                  <select class="select" v-model="register.Gender" name="Gender" v-validate="'required'"
                                    :class="{
      input: true,
      'is-danger': errors.has('Gender'),
    }">
                                    <option value="m">ذكر</option>
                                    <option value="f">أنثي</option>
                                  </select>
                                  <span v-show="errors.has('Gender')" class="help is-danger has-text-centered">{{
      errors.first("Gender") }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">مدينة الميلاد</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-medium" v-model="register.PlaceOfBirth" type="text" v-validate="{
      is: false,
      max: 20,
      required: true,
      regex: /^[\u0621-\u064A ]+$/,
    }" placeholder="مدينة الميلاد" name="PlaceOfBirth" :class="{
      input: true,
      'is-danger': errors.has('PlaceOfBirth'),
    }" />
                                <span v-show="errors.has('PlaceOfBirth')" class="help is-danger has-text-centered">{{
      errors.first("PlaceOfBirth") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">تاريخ الميلاد</label>

                          <div class="field-body">
                            <v-date-picker mode="single" v-model="register.DOB" name="DOB" v-validate="'required'"
                              class="is-fullwidth" locale="ar">
                              <b-field :expanded="true" :class="{ 'is-danger': errors.has('DOB') }" size="is-medium"
                                class="is-fullwidth">
                                <b-input readonly type="text" size="is-medium" class="is-fullwidth"
                                  :value="dateformat(register.DOB)" placeholder="تاريخ الميلاد" expanded></b-input>
                                <span v-show="errors.has('DOB')" class="help is-danger is-centered">{{
      errors.first("DOB") }}</span>

                                <span v-show="errors.has('age')" class="help is-danger is-centered">{{
      errors.first("age") }}</span>
                              </b-field>
                            </v-date-picker>
                            <input type="text" style="display: none" v-model="age" name="age"
                              v-validate="'min_value:18'" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column">
                        <div class="field is-fullwidth">
                          <label class="label is-medium">الاسم الثلاثي بالحروف اللاتينية</label>

                          <div class="field-body">
                            <div class="field has-addons is-fullwidth">
                              <p class="control is-expanded">
                                <input v-model="register.LatinFamilyName" name="LatinFamilyName"
                                  class="input has-text-left is-medium is-english" type="text" autofocus
                                  placeholder="اللقب" v-validate="{
      max: 20,
      required: true,
      regex: /^[A-Za-z ]+$/,
    }" :class="{
      input: true,
      'is-danger': errors.has('LatinFamilyName'),
    }" />
                                <span v-show="errors.has('LatinFamilyName')" class="help is-danger is-centered">{{
      errors.first("LatinFamilyName") }}</span>
                              </p>
                              <p class="control is-expanded">
                                <input v-model="register.LatinFatherName" name="LatinFatherName"
                                  class="input has-text-left is-medium is-english" type="text" autofocus
                                  placeholder="اسم الأب" v-validate="{
      max: 20,
      required: true,
      regex: /^[A-Za-z ]+$/,
    }" :class="{
      input: true,
      'is-danger': errors.has('LatinFatherName'),
    }" />
                                <span v-show="errors.has('LatinFatherName')" class="help is-danger is-centered">{{
      errors.first("LatinFatherName") }}</span>
                              </p>

                              <p class="control is-expanded">
                                <input v-model="register.LatinFirstName"
                                  class="input has-text-left is-medium is-english" type="text" autofocus
                                  name="LatinFirstName" placeholder="اسم الزبون" v-validate="{
      max: 20,
      required: true,
      regex: /^[A-Za-z ]+$/,
    }" :class="{
      input: true,
      'is-danger': errors.has('LatinFirstName'),
    }" />
                                <span v-show="errors.has('LatinFirstName')" class="help is-danger is-centered">{{
      errors.first("LatinFirstName") }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">الحالة الاجتماعية</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <div class="select is-fullwidth is-medium">
                                  <select class="select" v-model="register.MartialStatus" name="MartialStatus"
                                    v-validate="'required'" :class="{
      input: true,
      'is-danger': errors.has('MartialStatus'),
    }">
                                    <option value="1">أعزب</option>
                                    <option value="2">متزوج</option>
                                    <option value="3">مطلق</option>
                                    <option value="4">ارمل</option>
                                  </select>
                                </div>
                                <span v-show="errors.has('MartialStatus')" class="help is-danger is-centered">{{
      errors.first("MartialStatus") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">عدد افراد الاسرة</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input v-model="register.FamilyMembersCount" name="FamilyMembersCount"
                                  class="input has-text-left is-medium is-english" type="text" autofocus
                                  v-validate="'numeric'" :class="{
      input: true,
      'is-danger':
        errors.has('FamilyMembersCount'),
    }" />
                                <span v-show="errors.has('FamilyMembersCount')" class="help is-danger is-centered">{{
      errors.first("FamilyMembersCount")
    }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">الجنسية</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <div class="select is-fullwidth is-medium">
                                  <select class="select" v-validate="'required'" name="MainNationality"
                                    v-model="register.MainNationality" oninput="setCustomValidity('')"
                                    placeholder="الفرع">
                                    <option v-for="nationality in nationalities" v-bind:key="nationality.code"
                                      v-bind:value="nationality.code">
                                      {{ nationality.ar_name }}
                                    </option>
                                  </select>
                                </div>
                                <span v-show="errors.has('MainNationality')" class="help is-danger is-centered">{{
      errors.first("MainNationality") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <div class="field-body">
                            <label class="checkbox">
                              <input type="checkbox" v-model="register.IsFamilyGuardian" />
                              رب اسرة
                            </label>
                          </div>
                        </div>
                        <div class="field">
                          <input class="input is-medium has-text-centered is-english"
                            v-model="register.FamilyRegistrationNumber" v-validate="{
      max: 20,
      required: register.IsFamilyGuardian,
    }" v-show="register.IsFamilyGuardian" type="text" placeholder="رقم القيد"
                            name="FamilyRegistrationNumber" :class="{
      input: true,
      'is-danger': errors.has(
        'FamilyRegistrationNumber'
      ),
    }" />
                          <span v-show="errors.has('FamilyRegistrationNumber') &&
      register.IsFamilyGuardian
      " class="help is-danger has-text-centered">{{
      errors.first("FamilyRegistrationNumber")
    }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex-card light-bordered hover-inset card-overflow">
                <div class="flex-card-header">
                  <div class="header-control">
                    <i class="sl sl-icon-doc"></i>
                  </div>
                  <div class="header-info">
                    <div class="header-title mt-20 mb-20 is-primary">
                      <strong>بيانات الوثائق الشخصية</strong>
                    </div>
                  </div>
                </div>
                <div class="card-body is-medium">
                  <div class="content">
                    <table class="table">
                      <tbody>
                        <tr>
                          <th width="50">اسم الوثيقة</th>
                          <th width="10">رقم الوثيقة</th>
                          <th width="15">تاريخ إنتهاء الصلاحية</th>
                        </tr>
                        <!-- <tr>
                          <td data-th="Name">البطاقة الشخصية</td>
                          <td data-th="Role">
                            <input
                              v-model="register.IDCardNo"
                              name="IDCardNo"
                              class="input has-text-left is-medium is-english"
                              type="text"
                              autofocus
                              placeholder="رقم البطاقة"
                              v-validate="{ required: this.cardrequired }"
                            />
                            <span
                              v-show="errors.has('IDCardNo')"
                              class="help is-danger is-centered"
                              >{{ errors.first("IDCardNo") }}</span
                            >
                          </td>
                          <td data-th="Projects">
                            <input
                              class="input is-medium"
                              name="IDCardPlaceOfIssue"
                              v-model="register.IDCardPlaceOfIssue"
                              v-validate="{
                                required: this.cardrequired,
                                regex: /^[\u0621-\u064A ]+$/,
                              }"
                              type="text"
                              placeholder="مكان الإصدار"
                            />
                            <span
                              v-show="errors.has('IDCardPlaceOfIssue')"
                              class="help is-danger is-centered"
                              >{{ errors.first("IDCardPlaceOfIssue") }}</span
                            >
                          </td>
                        </tr> -->

                        <tr>
                          <td data-th="Name">جواز السفر</td>
                          <td data-th="Role">
                            <input v-model="register.PassportNO" name="PassportNO"
                              class="input has-text-left is-medium is-english" type="text" placeholder="رقم الجواز"
                              v-validate="{ required: this.passportrequired }" />
                            <span v-show="errors.has('PassportNO')" class="help is-danger is-centered">{{
      errors.first("PassportNO") }}</span>
                          </td>
                          <td data-th="Projects">
                            <div class="field-body">
                              <v-date-picker mode="single" v-model="register.PassportDateOfExpiration"
                                name="PassportDateOfExpiration" v-validate="'required'" class="is-fullwidth"
                                locale="ar">
                                <b-field :expanded="true" :class="{
      'is-danger': errors.has(
        'PassportDateOfExpiration'
      ),
    }" size="is-medium" class="is-fullwidth">
                                  <b-input readonly type="text" size="is-medium" class="is-fullwidth" :value="dateformat(
      register.PassportDateOfExpiration
    )
      " placeholder="تاريخ إنتهاء الصلاحية" expanded></b-input>
                                  <span v-show="errors.has('PassportDateOfExpiration')
      " class="help is-danger is-centered">{{
      errors.first("PassportDateOfExpiration")
    }}</span>
                                </b-field>
                              </v-date-picker>
                            </div>
                            <!-- <input
                              class="input is-medium"
                              name="PassportPlaceOfIssue"
                              v-model="register.PassportPlaceOfIssue"
                              v-validate="{
                                required: this.passportrequired,
                                regex: /^[\u0621-\u064A ]+$/,
                              }"
                              type="text"
                              placeholder="مكان الإصدار"
                            />
                            <span
                              v-show="errors.has('PassportPlaceOfIssue')"
                              class="help is-danger is-centered"
                              >{{ errors.first("PassportPlaceOfIssue") }}</span
                            > -->
                          </td>
                        </tr>

                        <tr v-if="!(register.MainNationality != 'LY')">
                          <td data-th="Name">الرقم الوطني</td>
                          <td data-th="Role">
                            <input v-model="register.NID" name="NID"
                              class="input has-text-centered is-english is-medium" type="text" autofocus
                              placeholder="الرقم الوطني" v-validate="register.MainNationality === 'LY'
        ? {
          regex: NIDRegEx,
          required: true,
          numeric: true,
          min: nidmax,
          max: nidmax,
        }
        : ''
      " :class="{
      input: true,
      'is-PassportNO': errors.has('NID'),
    }" />
                            <span v-show="errors.has('NID') || checkFirst5NID" class="help is-danger is-centered">{{ errors.first("NID")
                              }}</span>
                          </td>
                          <td data-th="Projects">
                            <input class="input is-medium" type="text" placeholder disabled />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="flex-card light-bordered card-overflow">
                <div class="flex-card-header">
                  <div class="header-control">
                    <i class="sl sl-icon-pin"></i>
                  </div>
                  <div class="header-info">
                    <div class="header-title mt-20 mb-20 is-primary">
                      <strong>بيانات عنوان السكن والتواصل</strong>
                    </div>
                  </div>
                </div>
                <div class="card-body is-medium">
                  <div class="content">
                    <div class="columns">
                      <div class="column is-fullwidth">
                        <div class="field">
                          <label class="label is-large">
                            الهاتف النقال المستخدم للعمليات المصرفية
                            <span class="tag is-warning is-bold has-text-black is-medium is-hidden-mobile">هذا الهاتف
                              سيستخدم لتأكيد بعض العمليات
                              المصرفية</span>
                            <span class="tag is-warning is-bold has-text-black is-small is-hidden-desktop">هذا الهاتف
                              سيستخدم لتأكيد بعض العمليات
                              المصرفية</span>
                          </label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-large has-text-centered is-english" v-model="register.MobileNo"
                                  v-validate="{
      required: true,
      numeric: true,
      regex: /^09\d{8}$/,
    }" type="text" placeholder="الهاتف النقال" name="MobileNo" :class="{
      input: true,
      'is-danger': errors.has('MobileNo'),
    }" />
                                <span v-show="errors.has('MobileNo')" class="help is-danger has-text-centered">{{
      errors.first("MobileNo") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column is-fullwidth">
                        <div class="field">
                          <label class="label is-large">
                            الهاتف النقال المربوط بالرقم الوطني
                            <span class="tag is-warning is-bold has-text-black is-medium is-hidden-mobile">هذا الهاتف
                              المربوط بالرقم الوطني
                            </span>
                            <span class="tag is-warning is-bold has-text-black is-small is-hidden-desktop">هذا الهاتف
                              المربوط بالرقم الوطني
                            </span>
                          </label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-large has-text-centered is-english"
                                  v-model="register.NidMobileNo" v-validate="{
      required: true,
      numeric: true,
      regex: /^09\d{8}$/,
    }" type="text" placeholder="الهاتف النقال" name="NidMobileNo" :class="{
      input: true,
      'is-danger': errors.has('NidMobileNo'),
    }" />
                                <span v-show="errors.has('NidMobileNo')" class="help is-danger has-text-centered">{{
      errors.first("NidMobileNo") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">البريد الالكتروني</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-medium" v-model="register.Email" v-validate="'email'" type="text"
                                  placeholder="البريد الالكتروني" name="Email" :class="{
      input: true,
      'is-danger': errors.has('Email'),
    }" />
                                <span v-show="errors.has('Email')" class="help is-danger has-text-centered">{{
      errors.first("Email") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">الشارع</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-medium" v-model="register.Street" v-validate="'required|max:20'"
                                  type="text" placeholder=" الشارع" name="Street" :class="{
      input: true,
      'is-danger': errors.has('Street'),
    }" />
                                <span v-show="errors.has('Street')" class="help is-danger has-text-centered">{{
      errors.first("Street") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">المنطقة</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-medium" v-model="register.District"
                                  v-validate="'required|max:20'" type="text" placeholder=" المنطقة" name="District"
                                  :class="{
      input: true,
      'is-danger': errors.has('District'),
    }" />
                                <span v-show="errors.has('District')" class="help is-danger has-text-centered">{{
      errors.first("District") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="column">
                        <div class="field">
                          <label class="label is-medium">المدينة</label>

                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <input class="input is-medium" v-model="register.City" v-validate="'required|max:20'"
                                  type="text" placeholder=" المدينة" name="City" :class="{
                                    input: true,
                                    'is-danger': errors.has('City'),
                                  }" />
                                <span v-show="errors.has('City')" class="help is-danger has-text-centered">{{
                                  errors.first("City") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <section class="section">
                <div class="container">
                  <div class="columns is-centered">
                    <div class="column is-half">
                      <vue-recaptcha sitekey="6Lf4BRsqAAAAAK2Q1H7mUN_sm7s3zcVRVAL2OnL6" @verify="recaptchaSolved = true"
                        @expired="recaptchaSolved = false" @error="recaptchaSolved = false">
                      </vue-recaptcha>
                    </div>
                  </div>
                </div>
              </section>
              <!-- <hr> 

                <router-link to="/verify">
                  <a class="button button-cta primary-btn is-large">
                    <b>موافقة على شروط الإستخدام والتسجيل</b>
                  </a>
              </router-link>-->
              <div class="section" v-show="errors.items.length > 0">
                <article class="message msg-danger">
                  <h4 class="message-header">
                    <span>هناك خطأ</span>
                    <span class="warining" aria-label="delete"></span>
                  </h4>
                  <div class="message-body">
                    <span class="help is-danger is-bold pb-10">رجاء معالجة هذه الأخطاء قبل الأستمرار</span>

                    <span v-for="error in errors.items" v-bind:key="error.id"
                      class="help is-danger has-text-centered">{{ error.msg }}</span>
                  </div>
                </article>
              </div>

              <article class="message msg-danger" v-if="errormessage">
                <h4 class="message-header">
                  <span>هناك خطأ في تسجيل</span>
                  <span class="warining" aria-label="delete"></span>
                </h4>
                <div class="message-body">
                  <span class="help is-danger has-text-centered">{{
                    failmessage
                    }}</span>
                </div>
              </article>


              <div class="field mt-40 mb-40 has-text-centered" style="padding: 25px; background: #f5f5f5; border-radius: 10px; border: 1px solid #eee;">
                <div class="control">
                  <label class="checkbox is-size-5" style="display: flex; align-items: center; justify-content: center;">
                    <input type="checkbox" v-model="register.IsAgreeOnTerms" style="width: 22px; height: 22px; cursor: pointer;" />
                    <span style="margin-right: 12px;">أوافق على <a @click="showTerms" style="cursor: pointer; text-decoration: underline; color: #209cee; font-weight: bold;">الشروط والأحكام</a></span>
                  </label>
                </div>
              </div>

              <button class="button primary-btn is-medium mt-40 mb-40 is-hidden-mobile" type="submit"
                :disabled="errors.items.length > 0 || !recaptchaSolved || !checkFirst5NID || !register.IsAgreeOnTerms">
                <i class="fa fa-check"></i>
                <b>موافقة على شروط الإستخدام والتسجيل</b>
              </button>

              <button class="button primary-btn mt-40 is-small is-mobile-only is-hidden-desktop is-hidden-tablet"
                type="submit" :disabled="errors.items.length > 0 || !recaptchaSolved || !checkFirst5NID || !register.IsAgreeOnTerms">
                <i class="fa fa-check"></i>
                <p class="subtitle is-6 has-text-white has-text-bold">
                  موافقة على شروط الإستخدام والتسجيل
                </p>
              </button>
            </form>
            <hr />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style>
.my-date-picker {
  width: 300px;
  /* Set your desired width value */
}
</style>
<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";
import { VueRecaptcha } from "vue-recaptcha";

function pad(str, max) {
  str = str.toString();
  return str.length < max ? pad("0" + str, max) : str;
}

const regexMessageAr = "  يجب ان يحتوى على حروف عربية فقط";

const regexMessageEn = "  يجب ان يحتوى على حروف لاتنية فقط";

export default {
  name: "register",
  components: { VueRecaptcha },
  data() {
    return {
      recaptchaSolved: false,
      branches: "",
      age: 0,
      servicenumber: 201,
      accountnumber: "",
      branchnumber: "",
      branchloading: false,
      hasWorkingCalander: false,
      nationalities: "",
      is_unemployed: false,
      register: {
        Branch_id: "",
        MainAccountNo: "",
        OldMainAccountNo: "",
        FirstName: "",
        FatherName: "",
        GrandFatherName: "",
        FamilyName: "",
        Gender: "",
        PlaceOfBirth: "",
        DOB: null,
        MotherName: "",
        MotherFatherName: "",
        MotherGrandFatherName: "",
        MotherFamilyName: "",
        LatinFirstName: "",
        LatinFatherName: "",
        LatinFamilyName: "",
        MartialStatus: "",
        FamilyMembersCount: 1,
        MainNationality: "LY",
        IDCardNo: "",
        IDCardPlaceOfIssue: "",
        IDCardDateOfIssue: null,
        IDCardDateOfExpiration: null,
        PassportNO: "",
        PassportPlaceOfIssue: "",
        PassportDateOfIssue: null,
        PassportDateOfExpiration: null,
        NID: "",
        Street: "",
        District: "",
        City: "",
        Email: "",
        MobileNo: "",
        NidMobileNo: "",
        YearsOfWork: "",
        JobPosition: "",
        OtherPhoneNumber: "",
        OtherIdentification: "",
        OtherIdentificationNo: "",
        IdentificationType: "",
        OtherNationality: "",
        PreviousEmployerName: "",
        EmployerAddress: "",
        EmployerNo: "",
        IsFamilyGuardian: false,
        FamilyRegistrationNumber: "",
        IsAgreeOnTerms: false,
        edu_info: [false, false, false, false, false, ""],
        job_info: {
          is_gov: false,
          is_private: false,
          is_retired: false,
          is_student: false,
          is_freelancer: false,
          freelancer_activity: "",
          is_unemployed: false,
          is_other: false,
          other: "",
        },
      },
      local: "ar",
      errormessage: false,
      isLoading: false,
      isBranchLoading: false,
      isBranchOk: false,
      isBranchFound: false,
      isCardModalActive: false,
      termsPopup: false,
      terms: null,
      failmessage: "",
      noWorkingMessage: "",
      monthNames: [
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليو",
        "أغسطس",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر",
      ],
      dayNames: [
        "الاحد",
        "الأثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعه",
        "السبت",
      ],
    };
  },
  methods: {
    checkWorkingCalender() {

      axios
        .get("/scheduler/getCurrentWC/" + this.register.Branch_id)
        .then((response) => {
          if (response.data.status == "success") {
            this.hasWorkingCalander = true;
          } else {
            this.hasWorkingCalander = false;
            this.noWorkingMessage =
              "الفرع الذي اخترته لا يستقبل طلبات التسجيل في الصحارى أونلاين هذه الفترة، نأمل منك إعادة المحاولة في وقت آخر.";
          }
        })
        .catch((error) => { });
    },
    dateformat(date) {
      if (date != null) return moment(date).format("YYYY-MM-DD");
      else return null;
    },
    showTerms() {
      this.termsPopup = true;
      if (!this.terms) {
        this.getTerms();
      }
    },
    getTerms() {
      axios
        .get("/kyc/terms")
        .then((response) => {
          if (response.data.status === "success") {
            this.terms = response.data.data;
          }
        })
        .catch((error) => { });
    },
    validateBeforeSubmit() {  
      if (
        this.registerMainAccountNo == "" &&
        this.register.OldMainAccountNo == ""
      ) {
        this.errormessage = true;
        this.failmessage = "رجاء ادخال رقم حسابكم القديم أو الجديد";
      } else {
        if (this.register.MainAccountNo != "") {
          this.register.OldMainAccountNo = "";
        }
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.isCardModalActive = true;

            return;
          }
        });
      }
    },

    pad(str, max) {
      str = str.toString();
      return str.length < max ? pad("0" + str, max) : str;
    },
    generateAccountNo() {
      this.register.OldMainAccountNo =
        pad(this.register.Branch_id, 3) +
        this.servicenumber +
        pad(this.accountnumber, 9);
    },
    signUp() {
        this.isLoading = !this.isLoading;
        this.register.DOB = moment(this.register.DOB).format("YYYY-MM-DD");
        this.register.PassportDateOfExpiration = moment(
          this.register.PassportDateOfExpiration
        ).format("YYYY-MM-DD");
        axios
          .post("customer/add", this.register)
          .then((response) => {
            this.isLoading = !this.isLoading;

            if (response.data.status === "success") {
              this.$router.push("/verify/" + response.data.CustomerID);
            } else {
              this.isCardModalActive = false;
              this.errormessage = true;
              this.failmessage = response.data.message;
            }
          })
          .catch((error) => {
            this.isLoading = !this.isLoading;

            this.errormessage = true;
          });
    },
  },
  created() {
    this.$validator.localize("ar", {
      messages: arabic.messages,
      fieldlength: 20,
      attributes: {
        OldMainAccountNo: "رقم الحساب القديم",
        MainAccountNo: "رقم الحساب الجديد",
        Branch_id: " الفرع المصرفي",
        accountnumber: "رقم الحساب",
        FirstName: "اسم الزبون",
        FatherName: "اسم الأب",
        GrandFatherName: "اسم الجد",
        FamilyName: "اللقب",
        MotherName: "اسم الأم",
        MotherFatherName: "أب الأم",
        MotherGrandFatherName: "جد الأم",
        MotherFamilyName: "لقب الأم",
        PlaceOfBirth: "مدينة الميلاد",
        Gender: "الجنس",
        DOB: "تاريخ الميلاد",
        LatinFirstName: "اسم لاتيني للزبون",
        LatinFatherName: "اسم لاتيني للأب",
        LatinFamilyName: "اللقب لاتيني ",
        MartialStatus: "الحالة الاجتماعية",
        FamilyMembersCount: "عدد افراد الاسرة",
        MainNationality: "الجنسية",
        IDCardNo: "رقم البطاقة",
        IDCardPlaceOfIssue: "مكان إصدار البطاقة",
        IDCardDateOfIssue: "تاريخ إصدار البطاقة",
        IDCardDateOfExpiration: "تاريخ إنتهاء البطاقة",
        PassportNO: "رقم الجواز",
        PassportPlaceOfIssue: "مكان إصدار الجواز",
        PassportDateOfIssue: "تاريخ إصدار الجواز",
        PassportDateOfExpiration: "تاريخ إنتهاء الجواز",
        NID: "الرقم الوطني",
        Street: "الشارع",
        District: "المنطقة",
        City: "المدينة",
        Email: "البريد الالكتروني",
        MobileNo: "الهاتف النقال",
        NidMobileNo: "الهاتف النقال المربوط بالرقم الوطني",
        YearsOfWork: "عدد سنوات العمل ككل",
        JobPosition: "المسمي الوظيفي",
        OtherNationality: "الجنسية اخرى",
        PreviousEmployerName: "جهة العمل السابقة",
        EmployerAddress: "عنوان جهة العمل",
        EmployerNo: "هاتف جهة العمل",
        freelancer_activity: "نشاط العمل",
        Otherjob: "عمل اخر",
        IsFamilyGuardian: "رب اسرة",
        FamilyRegistrationNumber: "رقم القيد",
      },
      custom: {
        age: {
          min_value: "عمر زبون يجب ان يكون فوق 18 عاماً",
        },
        FirstName: {
          regex: "اسم الزبون " + regexMessageAr,
        },
        FatherName: {
          regex: "اسم الأب " + regexMessageAr,
        },
        GrandFatherName: {
          regex: "اسم الجد " + regexMessageAr,
        },
        FamilyName: {
          regex: "اللقب " + regexMessageAr,
        },
        MotherName: {
          regex: "اسم الأم " + regexMessageAr,
        },
        MotherFatherName: {
          regex: "اسم أب الأم " + regexMessageAr,
        },
        MotherGrandFatherName: {
          regex: "اسم جد الأم " + regexMessageAr,
        },
        MotherFamilyName: {
          regex: "لقب الأم " + regexMessageAr,
        },
        PlaceOfBirth: {
          regex: "مدينة الميلاد " + regexMessageAr,
        },
        LatinFamilyName: {
          regex: "لقب لاتيني" + regexMessageEn,
        },
        LatinFatherName: {
          regex: "اسم جد لاتيني " + regexMessageEn,
        },
        LatinFirstName: {
          regex: "اسم الزبون لاتيني " + regexMessageEn,
        },
        IDCardPlaceOfIssue: {
          regex: "مكان اصدار البطاقة " + regexMessageAr,
        },
        PassportPlaceOfIssue: {
          regex: "مكان اصدار الجواز " + regexMessageAr,
        },
        MobileNo: {
          regex: "رقم الهاتف يجب ان يبدا ب(09) ويليه ثمان ارقام ",
        },
        NidMobileNo: {
          regex: "رقم الهاتف يجب ان يبدا ب(09) ويليه ثمان ارقام ",
        },
        NID: {
          max:
            "الحقل الرقم الوطني يجب ان يحتوي على " +
            this.nidmax +
            " رقم على الأكثر.",
          min:
            "الحقل الرقم الوطني يجب ان يحتوي على " +
            this.nidmax +
            " رقم على الأقل.",
          regex: " الرقم الوطني يجب ان يبدا ب 1 او 2 و مطابق لتاريخ الميلاد",
        },
      },
    });
  },
  computed: {
    NIDRegEx:function(){
      const reg = `^(1|2)${moment(this.register.DOB).year()}.*$`
      return new RegExp(reg)
    },
    checkFirst5NID: function(){
      const FISRT5CHARS = this.register.NID.toString().substring(0,5);
      const GENDER_DIGIT = this.register.Gender === 'm' ? 1:2;
      const BIRTH_YEAR = moment(this.register.DOB).year();

      return String(FISRT5CHARS) === (GENDER_DIGIT + '' + BIRTH_YEAR)
    },
    nidmax: function () {
      // `this` points to the vm instance
      var num = 12;

      this.$validator.localize("ar", {
        custom: {
          NID: {
            max:
              "الحقل الرقم الوطني يجب ان يحتوي على " + num + " رقم على الأكثر.",
            min:
              "الحقل الرقم الوطني يجب ان يحتوي على " + num + " رقم على الأقل.",
          },
        },
      });
      return num;
    },
    cardrequired() {
      if (this.register.PassportNO == null || this.register.PassportNO == "") {
        return true;
      }
      return false;
    },
    passportrequired() {
      if (this.register.IDCardNo == null || this.register.IDCardNo == "") {
        return true;
      }
      return false;
    },

    inputState() {
      if (!this.selectedValue) {
        return {
          type: "is-danger",
          message: "Date required.",
        };
      }
      return {
        type: "is-primary",
        message: "",
      };
    }
  },
  watch: {
    "register.DOB": function (val) {
      this.age = moment().diff(
        moment(this.register.DOB).format("YYYY-MM-DD"),
        "years"
      );
      // alert( );
    },
    "register.Gender": function (val) {
      if (this.register.Gender === "m") {
        this.register.NID = "1" + this.register.NID.slice(1);
      } else {
        this.register.NID = "2" + this.register.NID.slice(1);
      }
    },

    "register.NID": function (val) {
      if (this.register.NID.charAt(0) == 1) {
        this.register.Gender = "m";
      } else {
        this.register.Gender = "f";
      }
    },
  },
  mounted() {
    moment.locale("en");
    this.branchloading = true;
    axios
      .get("branches/active/")
      .then((response) => {
        this.branches = response.data.data;
        this.branchloading = false;
      })
      .catch((error) => {
        // this.$router.push('/');
      });

    var nationalitiesfile = require("@/data/nationalities.json");
    this.nationalities = nationalitiesfile.data;
  },
};
</script>
